import Vue from 'vue'
import axios from 'axios'

const axiosIns = axios.create({
   baseURL: 'https://zip1993.co.th/api/',
  //baseURL: 'http://localhost:3035/api/',
  headers: {
    'Access-Control-Allow-Origin': '*',
    'Content-type': 'application/json'
  }
})

Vue.prototype.$http = axiosIns

export default axiosIns
